

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { SVGPathData, encodeSVGPath } from 'svg-pathdata';

import * as def from '@/definitions'
import { Const } from '@/const'

import { Rectangle } from '@/utilityModels/rectangle';
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { TextInfo } from '@/utilityModels/textInfo';
import { UnitHelper } from '@/helper/unitHelper';
import { MathHelper } from '@/helper/mathHelper';
import { UuidHelper } from '@/helper/uuidHelper';
import { RequestHelper } from '@/helper/requestHelper';
import { D3Helper } from '@/helper/d3Helper';
import { StringHelper } from '@/helper/stringHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { DebugHelper } from "@/helper/debugHelper";

import { FontManager } from '@/model/fontManager/fontManager';
import { Design } from '@/model/document2/page/surface/design/design';
import { D3TextLayer } from '@/model/document2/page/surface/design/layer/d3TextLayer';

@Component({
    components: {
    },
})
export default class D3TextLayerDrawer extends Vue 
{
    @Prop() private layer!: D3TextLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;
    // エディット対象かどうか？
    // 編集面選択に表示されている場合は、キャレットとプレースホルダを表示しないため
    @Prop({ default: false }) private isInEditor! : boolean;

    // 最小フォントサイズ(pt)
    static readonly MIN_FONT_SIZE = 1;
    static readonly MAX_FONT_SIZE = 720;

    private get isEditPreviewVisible()
    {
        if(this.isRendering) { return false; }
        return this.layer.inEdit;
    }

    private get currentDesign() : Design
    {
        return this.$store.getters.design;
    }
    
    // マウント済みフラグ
    private ismounted = false;
    mounted() { this.ismounted = true; }

    // 不透明度(0 ~ 1.0)
    private get opacity()
    {
        var value = this.layer.opacity / 100;
        if(value < 0) { value = 0; }
        if(value > 1) { value = 1; }
        return value;
    }

    // プレースホルダー
    private get isPlaceholderVisible()
    {
        // マウント前は表示しない
        if(!this.ismounted) { return false; }
        // 編集中は表示しない
        if(this.layer.inEdit) { return false; }
        // レンダリング中は表示しない
        if(this.isRendering) { return false; }
        // 印刷は表示しない
        var path = this.$router.currentRoute.path;
        if(path == "/PrintSetting") { return false; }
        // レイアウトは表示しない
        if(path == "/LayoutEditor") { return false; }
        // 文字列が空なら表示
        return this.layer.text == "";
    }

    // レイヤーテキスト取得
    private getLayerText() { return this.isPlaceholderVisible ? D3TextLayer.PLACEHOLDER : this.layer.text; }

    // 3d文字ソース
    private get textImageSource()
    {
        if(this.getLayerText() == "") { return ""; }
        
        if(!this.ismounted) { return ""; }

        // Edit中は更新しない
        if(this.isEditPreviewVisible) { return ""; }

        if(this.layer.fontJsonId != this.layer.fontId)
        {
            // フォント読み込みしてない
            var postData = {};
            postData["font"] = this.layer.fontId;
            var response = RequestHelper.getSync("get_font_json", postData);
            try
            {
                var jsonObject = JSON.parse(response);
                this.layer.fontJson = jsonObject.data;
            }
            catch(e)
            {
                DebugHelper.trace(e);
            }
            // フォント読み込み済みにする
            this.layer.fontJsonId = this.layer.fontId;
        }

        // 画像取得
        var fitFontSize = this.calcFontSizeFittingBaseSize();
        var image = D3Helper.getTextImage(this.layer, fitFontSize);
        return image;
    }

    // 基準とするサイズ
    private getBaseSize()
    {
        var sizeMm = Math.min(this.currentDesign.width, this.currentDesign.height) * 4;
        return UnitHelper.convert(sizeMm, "mm", "px");
    }

    // 現在のベースサイズにぴったりはまるフォントサイズを算定
    public calcFontSizeFittingBaseSize()
    {
        var text = this.getLayerText();
        // 自動サイズ設定する
        var tryFontSize = 1;
        var tryBeforeFontSize = 1;
        var step = 20;
        while(true)
        {
            var size = this.calcTextSize(text, UnitHelper.convert(tryFontSize, "pt", "mm") * this.scale, this.layer.fontId);

            if(size.width > this.layer.width * this.scale || size.height > this.layer.height * this.scale)
            {
                // レイヤー領域を超えてしまったので、フォントサイズを再設定する
                if(step == 20) { step = 10; }
                else if(step == 10) { step = 5; }
                else if(step == 5) { step = 2; }
                else if(step == 2) { step = 1; }
                else if(step == 1) { step = 0.3; }
                else if(step == 0.3) { step = 0.1; }
                else 
                {
                    // 以前のサイズで決定する
                    break;
                }

                // 以前のサイズにstepを加えて再チャレンジする
                tryFontSize = tryBeforeFontSize + step;
            }
            else
            {
                // レイヤー領域を超えない。stepを加えてもう一度計測する
                tryBeforeFontSize = tryFontSize;
                tryFontSize += step;
            }
            
            if(tryFontSize <= 0)
            {
                tryFontSize = D3TextLayerDrawer.MIN_FONT_SIZE;
                break;
            }

            if(tryFontSize >= D3TextLayerDrawer.MAX_FONT_SIZE)
            {
                tryFontSize = D3TextLayerDrawer.MAX_FONT_SIZE;
                tryBeforeFontSize = tryFontSize;
                break;
            }
        }

        return tryBeforeFontSize;
    }

    public get width() : number
    {
        return this.layer.width * (this.layer.width < 0 ? -1 : 1);
    }

    public get height() : number
    {
        return this.layer.height * (this.layer.height < 0 ? -1 : 1);
    }

    public get transform() : string
    {
        var transform = "";

        // オフセット
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // スケーリング
        transform += "scale(" + this.scale + ")";

        // 幅・高さによる反転を適用する
        transform += "scale(" + (this.layer.width < 0 ? -1 : 1) + " " + (this.layer.height < 0 ? -1 : 1) + ")";
        
        return transform;
    }

    // 文字情報配列
    private get characterInfoArray() : Array<{ 
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        uuid : string                   // UUID
    }>
    {
        var array = new Array();
        
        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return new Array(); }

        // 自動サイズ設定する
        var tryFontSize = 1;
        var tryBeforeFontSize = 1;
        var step = 20;
        while(true)
        {
            // 仮に配置してみる
            array = this.getCharacterInfoArray(tryFontSize);
            // 文字群の幅・高さを求める
            var minX = 0;
            var minY = 0;
            var maxX = 0;
            var maxY = 0;
            for(var i = 0; i < array.length; ++i)
            {
                var info = array[i];
                if(i == 0 || info.x < minX) { minX = info.x; }
                if(i == 0 || info.y < minY) { minY = info.y; }
                if(i == 0 || info.x + info.width > maxX) { maxX = info.x + info.width; }
                if(i == 0 || info.y + info.height > maxY) { maxY = info.y + info.height; }
            }
            var totalWidth = maxX - minX;
            var totalHeight = maxY - minY;

            if(totalWidth > this.layer.width * this.scale || totalHeight > this.layer.height * this.scale)
            {
                // レイヤー領域を超えてしまったので、フォントサイズを再設定する
                if(step == 20) { step = 10; }
                else if(step == 10) { step = 5; }
                else if(step == 5) { step = 2; }
                else if(step == 2) { step = 1; }
                else if(step == 1) { step = 0.3; }
                else if(step == 0.3) { step = 0.1; }
                else 
                {
                    // 以前のサイズで決定する
                    break;
                }

                // 以前のサイズにstepを加えて再チャレンジする
                tryFontSize = tryBeforeFontSize + step;
            }
            else
            {
                // レイヤー領域を超えない。stepを加えてもう一度計測する
                tryBeforeFontSize = tryFontSize;
                tryFontSize += step;
            }
            
            if(tryFontSize <= 0)
            {
                tryFontSize = D3TextLayerDrawer.MIN_FONT_SIZE;
                break;
            }

            if(tryFontSize >= D3TextLayerDrawer.MAX_FONT_SIZE)
            {
                tryFontSize = D3TextLayerDrawer.MAX_FONT_SIZE;
                tryBeforeFontSize = tryFontSize;
                break;
            }
        }

        // フォントサイズ決定
        array = this.getCharacterInfoArray(tryBeforeFontSize);

        return array;
    }

    private getCharacterInfoArray(fontSize = 1) : Array<{ 
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        uuid : string                   // UUID
    }>
    {
        var array = new Array();
        
        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return array; }

        // フォントマネージャー
        var fontManager : FontManager = this.$store.getters.fontManager;

        // 共通フォントサイズをビューのサイズに変更
        var scaledSameFontSize = UnitHelper.convert(fontSize, "pt", "mm") * this.scale;

        // スタート位置
        var x = this.layer.x * this.scale + this.offsetX;
        var y = this.layer.y * this.scale + this.offsetY;
        var maxHeight = 0;
        var numberInLine = 0;
        var text = this.getLayerText();
        var lines = text.split(/\r?\n/g);
        for(var lineIndex = 0; lineIndex < lines.length; ++lineIndex)
        {
            var line = lines[lineIndex];
            var characterCount = line.length;
            if(characterCount == 0)
            {
                // 改行しか存在しない行

                // "8"のサイズを測る
                var scaledFontSize = scaledSameFontSize;
                var size = this.calcTextSize("8", scaledFontSize, this.layer.fontId);
                // この高さだけ送る
                y += size.height;
                array.push({
                    character : "",
                    lineIndex : lineIndex,
                    characterIndex : 0,
                    x : x,
                    y : y,
                    width : 0.1,
                    height : size.height, 
                    fontSize : scaledFontSize,
                    uuid : UuidHelper.getUuid()
                });
                y += size.height;

                continue;
            }

            for(var characterIndex = 0; characterIndex < characterCount; ++characterIndex)
            {
                var letter = line.substr(characterIndex, 1);

                // この文字の大きさを測る

                var scaledFontSize = scaledSameFontSize;
                var isHankaku = StringHelper.isHankaku(letter);
                var size = this.calcTextSize(letter, scaledFontSize, this.layer.fontId);
                if(x + size.width > this.layer.x * this.scale + this.offsetX + this.layer.width * this.scale)
                {
                    // 描画位置が枠を超えてしまうので改行
                    // 改行前に同じ行にいる文字のy座標を下方向にずらす ... 描画指定位置が左下になるため
                    for(var i = 0; i < numberInLine; ++i)
                    {
                        var arrayIndex = array.length - 1 - i;
                        if(arrayIndex >= 0)
                        {
                            array[arrayIndex].y += maxHeight;
                        }
                    }
                    // 行送る
                    y += maxHeight;
                    x = this.layer.x * this.scale + this.offsetX;
                    maxHeight = 0;
                    numberInLine = 0;
                }

                array.push({
                    character : letter,
                    lineIndex : lineIndex,
                    characterIndex : characterIndex,
                    x : x,
                    y : y,
                    width : size.width,
                    height : size.height, 
                    fontSize : scaledFontSize,
                    uuid : UuidHelper.getUuid()
                });
                // 文字送り
                x += size.width;
                numberInLine++;
                // 最大高さ更新
                maxHeight = Math.max(maxHeight, size.height);
            } 
            // 改行
            // 改行前に同じ行にいる文字のy座標を下方向にずらす ... 描画指定位置が左下になるため
            for(var i = 0; i < numberInLine; ++i)
            {
                var arrayIndex = array.length - 1 - i;
                if(arrayIndex >= 0)
                {
                    array[arrayIndex].y += maxHeight;
                }
            }
            // 行送る
            y += maxHeight;
            x = this.layer.x * this.scale + this.offsetX;
            maxHeight = 0;
            numberInLine = 0;
        }

        return array;
    }

    // キャレットを表示するか
    private get charetVisible()
    {
        // レンダリング中は表示しない
        if(this.isRendering) { return false; }
        // エディット対象でなければ表示しない
        if(!this.isInEditor) { return false; }
        return this.layer.inEdit && this.layer.startPosition == this.layer.endPosition;
    }

    // キャレット位置
    // x1, y1, x2, y2
    private getCharetPos()
    {
        var info = this.getCharacterInfoFromPosition(this.layer.startPosition);
        if(info == null) { return { x1 : 0, y1 : 0, x2 : 0, y2 : 0}; }

        var x1 = 0;
        var y1 = 0;
        var x2 = 0;
        var y2 = 0;

        // 横書き
        if(info.isFirstInLine)
        {
            x1 = info.characterInfo.x;
            y1 = info.characterInfo.y - info.characterInfo.height;
            x2 = x1;
            y2 = y1 + info.characterInfo.height;
        }
        else
        {
            x1 = info.characterInfo.x + info.characterInfo.width;
            y1 = info.characterInfo.y - info.characterInfo.height;
            x2 = x1;
            y2 = y1 + info.characterInfo.height;
        }

        if(MathHelper.equals(x1, this.layer.x * this.scale + this.offsetX))
        {
            // キャレットがバウンディングボックスに隠れるので少しずらす
            x1 += 4;
            x2 = x1;
        }
        else if(MathHelper.equals(x1, this.layer.x * this.scale + this.offsetX + this.layer.width * this.scale))
        {
            // キャレットがバウンディングボックスに隠れるので少しずらす
            x1 -= 4;
            x2 = x1;
        }

        return { x1 : x1, y1 : y1, x2 : x2, y2 : y2 };
    }

    // 選択を表示するか
    private get selectionVisible()
    {
        // レンダリング中は表示しない
        if(this.isRendering) { return false; }
        // エディット対象でなければ表示しない
        if(!this.isInEditor) { return false; }
        return this.layer.inEdit && this.layer.startPosition != this.layer.endPosition;
    }

    // 選択領域
    private get selectionRectArray()
    {
        var start = Math.min(this.layer.startPosition, this.layer.endPosition);
        var end = Math.max(this.layer.startPosition, this.layer.endPosition);
        var rectArray = new Array();
        for(var i = start + 1; i <= end; ++i)
        {
            var info = this.getCharacterInfoFromPosition(i);
            if(info != null)
            {
                rectArray.push({
                    x : info.characterInfo.x, 
                    y : info.characterInfo.y - info.characterInfo.height, 
                    width : info.characterInfo.width, 
                    height : info.characterInfo.height
                });
            }
        }

        return rectArray;
    }

    private getCharacterStyle(characterInfo)
    {
        var style = {
            "font-family" : this.getFontFamily(),
            "font-size" : characterInfo.fontSize,
            "fill" : this.layer.textColor.hex
        };
        return style;
    }

    // positionを元にcharacterInfoを得る
    // characterInfo
    // isFirstInLine : [行の先頭かどうか]
    private getCharacterInfoFromPosition(position)
    {
        var indexPair = this.layer.getLineAndCharacterIndexFromPosition(position);
        var array = this.characterInfoArray;
        for(var info of array)
        {
            if(info.lineIndex == indexPair.lineIndex && info.characterIndex == indexPair.characterIndex)
            {
                return { characterInfo : info, isFirstInLine : indexPair.isFirstInLine };
            }
        }
        return null;
    }

    private get previewTransform()
    {
        var transform = "";

        // オフセット
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // オフセット
        transform += "translate(" + -offsetX + " " + -offsetY + ")";

        return transform;
    }

    private getFontFamily() : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(this.layer.fontId);
        return this.isRendering ? font.renderingFontName : font.toString();
    }

    private calcTextSize(str : string, fontSize : number, fontId : string = "", isBold : boolean = false, isItalic : boolean = false, isVertical : boolean = false)
    {
        var isHankaku = StringHelper.isHankaku(str);

        // fontSize -> pt
        var fontSizePt = UnitHelper.convert(fontSize / this.scale, "mm", "pt");
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(fontId);

        // fontFamily
        var fontFamily = fontManager.getFontFamilyName(fontId, isHankaku, false, isVertical);

        // weight
        var weight = "normal";
        if(font.weight == null)
        {
            // ウェイトがない場合はボールド設定を返す
            weight = isBold ? "bold" : "normal";
        }
        else
        {
            // ウェイトがある場合
            if(isBold)
            {
                weight = font.weight > 700 ? font.weight.toString() : "bold";
            }
            else
            {
                weight = font.weight.toString();
            }
        }

        // style
        var style = isItalic && fontManager.canItalic(fontId, isHankaku) ? "italic" : "normal";

        var ptSize = StringHelper.calcTextSizeOnSVGPt(str, fontSizePt, fontFamily, weight, style, isVertical);

        var width = UnitHelper.convert(ptSize.width, "pt", "mm") * this.scale;
        var height = UnitHelper.convert(ptSize.height, "pt", "mm") * this.scale;

        return { width : width, height : height };
    }
}
